import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { logger } from 'utils/logger';
import { kickUser } from 'features/users/actions';

export function* kickUserSaga(action: ReturnType<typeof kickUser>) {
  logger
    .remote({ action: true, tier: 1 })
    .info(`The user removed a participant with id=${action.payload.userId}`);

  yield call(SignalingSocket.send, {
    event: 'kickUser',
    data: {
      id: action.payload.userId,
      breakoutId: action.payload.breakoutId,
    },
  });
}
